import React from 'react';
import { ClipboardEdit, Paintbrush, Download } from 'lucide-react';

const steps = [
  {
    icon: <ClipboardEdit className="w-8 h-8" />,
    title: 'Enter Your Information',
    description: 'Fill in your details or import from LinkedIn'
  },
  {
    icon: <Paintbrush className="w-8 h-8" />,
    title: 'Select Your Template',
    description: 'Choose from our professional templates'
  },
  {
    icon: <Download className="w-8 h-8" />,
    title: 'Download Your PDF Resume',
    description: 'Get your perfectly formatted resume instantly'
  }
];

export default function HowItWorks() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
          How It Works
        </h2>
        
        <div className="grid md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="flex flex-col items-center text-center">
                <div className="w-16 h-16 bg-indigo-600 rounded-full flex items-center 
                  justify-center text-white mb-6">
                  {step.icon}
                </div>
                <h3 className="text-xl font-semibold mb-2">{step.title}</h3>
                <p className="text-gray-600">{step.description}</p>
              </div>
              
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-8 left-full w-full 
                  h-0.5 bg-indigo-200 -z-10" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}